import React from 'react';
import { useT } from '~app/core/BundleProvider';
import ButtonBox from '~app/features/app/components/ButtonBox';
import DragDropFilesUpload from '~app/features/saveLoad/components/DragDropFilesUpload';

// Component to upload reference file in grading tool
const AnswerKeyPage = ({
  answerKeyButtons,
  fileUploader,
  handleFileUpload,
  handleDragDrop,
}) => {
  const t = useT();
  return (
    <DragDropFilesUpload handleDrop={handleDragDrop}>
      <div className="ButtonBox_box ButtonBox__box-upload">
        <input
          type="file"
          id="file"
          value=""
          ref={fileUploader}
          style={{ display: 'none' }}
          onChange={handleFileUpload}
          aria-label={t('file-upload')}
          aria-hidden
        />
        <ButtonBox
          buttons={answerKeyButtons}
          title={t('answer-key')}
          description={t('answer-key-description')}
          descriptionStyle="ButtonBox__description-centered"
          padded={true}
        />
      </div>
    </DragDropFilesUpload>
  );
};

export default AnswerKeyPage;
